import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-skeleton-loading',
  templateUrl: './skeleton-loading.component.html',
  styleUrls: ['./skeleton-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonLoadingComponent {
  @Input() type: 'text' | 'card' | 'list' | 'calendar' | 'table' = 'text';
  @Input() lines: number = 3;
  @Input() width: string = '100%';
  @Input() height: string = '20px';
  @Input() animation: 'pulse' | 'wave' | 'none' = 'pulse';

  // Expor Array para o template
  Array = Array;

  get skeletonLines(): number[] {
    return Array(this.lines).fill(0);
  }

  get skeletonWidth(): string {
    return this.width;
  }

  get skeletonHeight(): string {
    return this.height;
  }

  get animationClass(): string {
    return `skeleton-${this.animation}`;
  }
}
